import { render } from "./Blocos.vue?vue&type=template&id=552b8a1e&scoped=true"
import script from "./Blocos.vue?vue&type=script&lang=js"
export * from "./Blocos.vue?vue&type=script&lang=js"

import "./Blocos.vue?vue&type=style&index=0&id=552b8a1e&lang=scss&scoped=true"

import exportComponent from "D:\\Projetos\\Git\\MINUS\\Sites\\site-gerencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552b8a1e"]])

export default __exports__